import React, { useEffect, useState } from "react";
import useSound from "use-sound";
import {
  SubTitle,
  Swiper,
  SubTitleInit,
  ArrowDiv,
  Wrapper,
} from "./SubTextStyled";
import { ReactComponent as HiSVG } from "../../../assets/hi.svg";
import { ReactComponent as LoSVG } from "../../../assets/lo.svg";
import loseSFX from "../../../assets/audio/hilo/loseSFX.mp3";
// import goForwardSFX from "../../../assets/audio/globals/goForwardSFX.mp3";

export default ({
  handleAbove,
  gameIsOn,
  picks,
  result,
  stateRound,
  floorFigure,
  handleAboveAnimation,
  userSettings,
  gameStates,
  audio,
}) => {
  const [win, setWin] = useState(false);
  const { won, currentCoef } = stateRound;

  const [arrowClick, setArrowClick] = useState(false);
  const [clicked, setClicked] = useState(null);

  const [playLoseSFX] = useSound(loseSFX, {
    volume: userSettings.volume,
  });
  // const [playGoForwardSFX] = useSound(goForwardSFX, {
  //   volume: userSettings.volume,
  // });
  useEffect(() => {
    if (won > 0) {
      setWin(true);
    } else {
      setWin(false);
    }
  }, [won]);

  // es akedan gasatania akkk raa undaaaa ?? :)))
  useEffect(() => {
    if (!gameIsOn && result && userSettings.sound === "1") {
      if (!win) {
        playLoseSFX();
      }
    }
  }, [gameIsOn, result, win, playLoseSFX, userSettings.sound]);

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  return (
    <>
      {gameIsOn && picks.length > 1 ? (
        <>
          <SubTitleInit fadeOut={gameIsOn && picks.length > 1}>
            start card
          </SubTitleInit>
          <Swiper pickAnim={picks.length * 40}>
            <Wrapper pickAnim={picks.length * 40}>
              {picks &&
                picks.slice(1).map((pick, index) => (
                  <ArrowDiv
                    pickAnim={-(picks.length * 40)}
                    arrowInit={gameIsOn && picks.length === 1}
                    key={index}
                    className={
                      (index === picks.slice(1).length - 1 && "last") || index
                    }
                    arrowClicked={clicked === index && arrowClick}
                    onClick={() => {
                      setAnimation(arrowClick, setArrowClick);
                      setClicked(index);
                      !arrowClick && userSettings.sound === "1" && audio();
                      setTimeout(() => {
                        handleAboveAnimation(true);
                        handleAbove("detailedHistory");
                      }, 150);
                    }}
                  >
                    {pick === "HI" ? (
                      <div>
                        <HiSVG />
                      </div>
                    ) : pick === "LO" ? (
                      <div>
                        <LoSVG />
                      </div>
                    ) : pick === "SAME" ? (
                      <div style={{ color: "#ffb000" }}>=</div>
                    ) : pick === "CHANGE" ? (
                      <div>-</div>
                    ) : null}
                  </ArrowDiv>
                ))}
            </Wrapper>
          </Swiper>
        </>
      ) : !gameIsOn && result ? (
        <SubTitle win={win} res={result}>
          win {win && currentCoef ? floorFigure(currentCoef, 2) : "0.00"}x
        </SubTitle>
      ) : (
        <SubTitleInit init={gameStates === "init"}>start card</SubTitleInit>
      )}
    </>
  );
};
